module.exports = __webpack_public_path__ + "img/bg.ef6b7864.jpg";